import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SUBSCRIPTION_URLS } from '../constants/subscription-routes.constant';
import { SubscriptionStore } from '../services/subscription.store';

export type SubscriptionStepRequirement = 'amount' | 'regimeFund' | 'employer';

export const stepGuard =
  (...requirements: SubscriptionStepRequirement[]): CanActivateFn =>
  () => {
    const store = inject(SubscriptionStore);
    const router = inject(Router);

    if (requirements.includes('amount') && !store.amount()) {
      return router.parseUrl(SUBSCRIPTION_URLS.amount);
    }

    if (requirements.includes('regimeFund') && !store.regimeFund()) {
      return router.parseUrl(SUBSCRIPTION_URLS.regimeFund);
    }

    if (requirements.includes('employer') && !store.employer()) {
      return router.parseUrl(
        store.hasEmployer()
          ? SUBSCRIPTION_URLS.employer
          : SUBSCRIPTION_URLS.addEmployer
      );
    }

    return true;
  };
